<template>
  <div class="watchCenterPage">
      <leftNav :navarr="navarr" v-on:isshow="changeurl" />
    <div class="main-center">
      <div
        class="closeTips"
        @mouseenter="showtotips()"
        @mouseleave="leavetips()"
        v-show="isshow"
      >
        <img src="../../assets/station/tips.png" alt="" />
        <div class="showtips" v-if="showtips">
          <img class="sanjiao" src="../../assets/station/sanjiao.png" alt="" />
          <div class="tip-btn" @click="closeallTips()">关闭所有</div>
          <div class="tip-btn" @click="closeotherTips()">关闭其他标签</div>
        </div>
      </div>
      <el-tabs
        v-model="editableTabsValue"
        type="card"
        closable
        @tab-remove="removeTab"
        @tab-click="changerouter"
        v-show="isshow"
      >
        <el-tab-pane
          v-for="(item, index) in editableTabs"
          :key="item.name"
          :label="item.title"
          :name="item.name"
        >
        </el-tab-pane>
      </el-tabs>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view
        :key="editableTabsValue"
        v-if="!$route.meta.keepAlive"
      ></router-view>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import leftNav from "../../components/leftNav";

export default {
  name: "watchCenterPage",
  data() {
    return {
      navarr: [
        { name: "监测管理", icon: require("@/assets/leftnav/lookMag.png") },
        { name: "评估报告", icon: require("@/assets/leftnav/safe.png") },
        { name: "数据详情", icon: require("@/assets/leftnav/dataDetile.png") },
        { name: "能源监测", icon: require("@/assets/leftnav/un.png") },
      ],
      isshow: true,
      editableTabsValue: "1",
      nowurl: "/stationList",
      editableTabs: [
        {
          title: "监测点列表",
          name: "1",
          router: "/stationList",
        },
      ],
      showtips: false,
      tabIndex: 1,
    };
  },
  methods: {
    changeurl(data) {
      this.nowurl = data;
      if (this.nowurl == "/stationList") {
        this.editableTabs = [
          {
            title: "监测点列表",
            name: "1",
            router: "/stationList",
          },
        ];
        this.isshow = true;
      } else if (this.nowurl == "/reportList" || this.nowurl == "/powerWatch") {
        this.isshow = false;
      } else if (this.nowurl == "/datalist") {
        this.editableTabs = [
          {
            title: "监测点列表",
            name: "1",
            router: "/datalist",
          },
        ];
        this.isshow = true;
      }
    },
    closeotherTips() {
      this.editableTabs.forEach((tab, index) => {
        if (tab.name == this.editableTabsValue) {
          this.editableTabs.length = 0;
          this.editableTabs.push(tab);
          this.$router.push(tab.router);
        }
      });
    },
    closeallTips() {
      this.editableTabs = [
        {
          title: "监测点列表",
          name: "1",
          router: "/stationList",
        },
      ];
      this.editableTabsValue = "1";
      this.tabIndex = 1;
      this.$router.push("/stationList");
    },
    changerouter() {
      this.editableTabs.forEach((tab, index) => {
        if (tab.name == this.editableTabsValue) {


          sessionStorage.setItem("saveid", tab.id);

          // if(tab.router=='/newstaPage'){
          //   sessionStorage.setItem("branchId", tab.branchId);
          //   sessionStorage.setItem("saveid", tab.id);
          // }else if(tab.router=='/numCenterPage/forzedata'){
          //   sessionStorage.setItem("branchId", tab.branchId);
          //   sessionStorage.setItem("siteName", tab.siteName);
          //   sessionStorage.setItem("terminalTypeName", tab.terminalTypeName);
          //   sessionStorage.setItem("imei", tab.imei);
          // }if(tab.router=='/saveReport/saveReportdetail'){
          //   sessionStorage.setItem("reportName", tab.reportName);
          //   sessionStorage.setItem("reportTime", tab.reportTime);
          //   sessionStorage.setItem("reportId", tab.reportId);
          //   sessionStorage.setItem("reportType", tab.reportType);
          // }
          this.$router.push(tab.router);
        }
      });
    },
    removeTab(targetName) {
      if (this.editableTabs.length > 1) {
        let tabs = this.editableTabs;
        let router = "";
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
                router = nextTab.router;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.$router.push(router);
        this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      }
    },
    leavetips() {
      this.showtips = false;
    },
    showtotips() {
      this.showtips = true;
    },
    outurl(){
      let that=this
      let val=this.$route.params.val
      console.log(val)
      for (let i = 0; i < that.editableTabs.length; i++) {
        if (that.editableTabs[i].title == val[0]) {
          //老监测点跳转
          that.editableTabsValue = that.editableTabs[i].name;
          that.$router.push(that.editableTabs[i].router);
          return;
        }
      }
      //新监测点添加
      let newTabName = ++that.tabIndex + "other";
      let router = val[3];
      that.editableTabs.push({
        title: val[0],
        name: newTabName,
        branchId: val[1],
        id: val[2],
        router: router,
      });
      localStorage.setItem("editableTabs",JSON.stringify(this.editableTabs) );
      localStorage.setItem("editableTabsValue", newTabName);
      that.editableTabsValue = newTabName;
      that.$router.push(router);

    }
  },
  mounted() {
    let that = this;
    Bus.$on("pushrouter", (val) => {
      for (let i = 0; i < that.editableTabs.length; i++) {
        if (that.editableTabs[i].title == val[0]) {
          //老监测点跳转

          that.editableTabsValue = that.editableTabs[i].name;
          that.$router.push(that.editableTabs[i].router);
          return;
        }
      }
      //新监测点添加
      let newTabName = ++that.tabIndex + "";
      let router = val[3];
      that.editableTabs.push({
        title: val[0],
        name: newTabName,
        branchId: val[1],
        id: val[2],
        router: router,
      });
      localStorage.setItem("editableTabs",JSON.stringify(this.editableTabs) );
      localStorage.setItem("editableTabsValue", newTabName);
      that.editableTabsValue = newTabName;
      that.$router.push(router);
    });
    Bus.$on("pushrouter2", (val) => {

      for (let i = 0; i < that.editableTabs.length; i++) {
        if (that.editableTabs[i].title == val[0]) {
          //老监测点跳转
          that.editableTabsValue = that.editableTabs[i].name;
          that.$router.push(that.editableTabs[i].router);
          return;
        }
      }
      //新监测点添加
      let newTabName = ++that.tabIndex + "other";
      let router = val[3];
      that.editableTabs.push({
        title: val[0],
        name: newTabName,
        branchId: val[1],
        id: val[2],
        router: router,
      });
      localStorage.setItem("editableTabs",JSON.stringify(this.editableTabs) );
      localStorage.setItem("editableTabsValue", newTabName);
      that.editableTabsValue = newTabName;
      that.$router.push(router);
    });

    Bus.$on("isshow", (val) => {

      // that.isshow=val
    });



  },
  created() {


  },
  watch: {
    nowurl() {},


  },
  components: {
    leftNav,
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.watchCenterPage {
  height: 100%;
  overflow: auto;
}
.main-center {
  width: calc(100% - 240px);
  height: 100%;
  display: inline-block;
  vertical-align: top;
  background-color: #ecf0f6;
  padding: 20px 24px;
  overflow: auto;
  position: relative;
}
.closeTips {
  cursor: pointer;
  position: absolute;
  top: 28px;
  right: 60px;
  z-index: 100;
  .showtips {
    width: 144px;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border: 1px solid #e4e7ed;
    position: absolute;
    top: 26px;
    left: -70px;
  }
  .sanjiao {
    position: absolute;
    top: -10px;
    left: 70px;
  }
  .tip-btn {
    color: #5a5e66;
    font-size: 14px;
    padding: 10px 20px;
  }
}
</style>
<style>
#app .main-center .el-tabs__header {
  margin-bottom: 0;
}
#app .main-center .el-tabs--card > .el-tabs__header .el-tabs__nav {
  background-color: #fff;
}
#app .main-center .el-tabs--card > .el-tabs__header .el-tabs__item {
  /*border-bottom: 1px solid #E4E7ED;*/
}
</style>
